import { Button, TabsItem, TabsList, styled } from "@woba/ds-web";

export const ToggleContainer = styled(TabsList, {
  borderColor: "$neutral-200",
  borderWidth: 1,
  borderStyle: "solid",
  borderRadius: "$sm",
  padding: 0,

  button: {
    "&:first-child": {
      "& > div > div": {
        borderRadius: "$sm 0 0 $sm",
      },
    },
    "&:last-child": {
      "& > div > div": {
        borderRadius: "0 $sm $sm 0",
      },
    },

    svg: {
      color: "$neutral-900",
    },
  },
});
export const ToggleItem = styled(TabsItem, {
  padding: 0,
  margin: 0,

  "&[data-state='active']": {
    background: "transparent",
    span: {
      color: "$neutral-900",
    },

    "&::after": {
      background: "transparent",
    },
  },
  "&:hover": {
    "&::after": {
      background: "$neutral-100",
      height: 0,
    },
  },
});

export const ToggleItemLabel = styled("span", {
  color: "$neutral-700",
  fontWeight: 500,
  fontSize: "14px",

  "&:hover": {
    color: "$neutral-900",
  },
});
